import { css } from 'lit';

export default css`
  /* States */
  --color-active: var(--color-primary-dark); /* Active state */
  --color-focus: var(--color-secondary);     /* Focus state */
  --color-error: var(--color-red-light);     /* Error state (normalized to red-light) */
  --color-success: var(--color-green);       /* Success state */
  --focus-ring: 0 0 0 3px rgba(37, 148, 227, 0.5); /* Focus ring */
  --opacity-disabled: 0.6;          /* Disabled opacity */
  --opacity-overlay: 0.5;           /* Overlay opacity */
  --outline-focus: var(--sm-line) solid var(--color-focus); /* Focus outline */

  /* Hover States */
  --color-hover: var(--color-primary-light-1, #c3d6e3); /* Hover */
  --color-menu-hover: #eeeaf3; /* Menu hover */
  --scale-hover: scale(0.95);       /* Hover scale */
  --translate-hover: translateX(var(--spacing-xs)); /* Hover translation */
  --shadow-focus: 0 0 0 3px var(--color-hover);
`;
